import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import MembershipIcon from "../../../Assets/Icons/membershipIcon.svg";
import DatePickerIcon from "../../../Assets/Icons/DatePickerIcon.svg";
import FundsIcon from "../../../Assets/Icons/fundsReceivedIcon.svg";
import RelaeseIcon from "../../../Assets/Icons/releaseIcon.svg";
import Loader from "../Loader";
import Box from "./Box";
import BreadCrumsHeader from "../BreadCrums";
import Funds from "./Funds";
import AccountsDetails from "./AccountsDetails";
import Withdrawals from "./Withdrawals";
import Target from "./Target";
import ReferredMerchants from "./ReferredMerchants";
import Frequency from "./Frequency";
import { getDashboardStats, getTarget } from "../../../services/fundraiserService";

const FundraiserDashboard = ({ items }) => {
  const dispatch = useDispatch();
  const [dashboardStats, setDashboardStats] = useState([]);
  const [selectedFrequency, setSelectedFrequency] = useState("Yearly");
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const fundraiserLoading = useSelector(
    (state) => state.fundraiserReducer.loading
  );

  const getStatsData = async () => {
    let timePeriod = "year";
    switch (selectedFrequency) {
      case "Today":
        timePeriod = "day";
        break;
      case "Weekly":
        timePeriod = "week";
        break;
      case "Monthly":
        timePeriod = "month";
        break;
      case "Yearly":
        timePeriod = "year";
        break;
      default:
        timePeriod = "year";
        break;
    }
    const statsPromise = await dispatch(
      getDashboardStats(timePeriod)
    )?.unwrap();
    if (statsPromise?.success === true) {
      setDashboardStats(statsPromise?.data);
    }
    setHasLoadedOnce(true);
  }

  useEffect(() => {
    getStatsData();
  },[selectedFrequency])
  const fundraiserBoxes = [
    {
      text: "Active Members",
      number: dashboardStats?.activeSubscriptions || 0,
      icon: MembershipIcon,
    },
    {
      text: "Memberships Lost",
      number: dashboardStats?.lostSubscriptions || 0,
      icon: MembershipIcon,
    },
    {
      text: "Renewals Due",
      number: dashboardStats?.renewalSubscriptions || 0,
      icon: DatePickerIcon,
    },
    {
      text: "Total Funds Raised",
      number: (
        <div className="flex flex-col leading-tight mt-1">
          <span className="text-[24px] sm:text-[28px] font-[700] text-[white] font-montserrat">${(dashboardStats?.lifetimeFunds / 100 || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          <span className="text-[10px] sm:text-[11px] font-[400] text-gray-200 font-poppins mt-1">
            This Month: ${(dashboardStats?.thisMonthFunds / 100 || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} | Last Month: ${(dashboardStats?.lastMonthFunds / 100 || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
      ),
      icon: FundsIcon,
    },
    {
      text: "Funds Pending Release",
      number: `$${(dashboardStats?.pendingFundsRelease / 100 || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      icon: RelaeseIcon,
    },
    {
      text: "Estimated Annual Income",
      number: (
        <div className="flex flex-col leading-tight mt-1">
          <span className="text-[24px] sm:text-[28px] font-[700] text-[white] font-montserrat">${((dashboardStats?.totalActiveSubscriptions || 0) * 19.99).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          <span className="text-[10px] sm:text-[11px] font-[400] text-gray-200 font-poppins mt-1">
            Avg. Revenue: $19.99/yr per member
          </span>
        </div>
      ),
      icon: FundsIcon,
    },
  ];

  const frequencies = [
    "Monthly",
    "Weekly",
    "Yearly",
    "Today"
  ];

  return (
    <>
      {hasLoadedOnce && fundraiserLoading ? <Loader /> : null}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center col-span-12 gap-3">
        <BreadCrumsHeader heading="Dashboard" items={items} />
        <Frequency selectedFrequency={selectedFrequency} setSelectedFrequency={setSelectedFrequency} frequencies={frequencies} className='frequency w-full sm:w-[60%] md:w-[50%] lg:w-[40%] xl:w-[30%] py-2 px-[1%] flex justify-center items-center'/>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 w-full gap-3 my-[2%]">
        {fundraiserBoxes?.map((b) => (
          <Box
            text={b?.text}
            number={b?.number}
            icon={b?.icon}
            mainClassName="box px-3 pt-1 pb-3 h-[100px]"
            textClassName="text-[12px] sm:text-[14px] font-poppins font-[600] text-[white]"
            numberClassName="text-[24px] sm:text-[28px] md:text-[36px] font-[700] text-[white] font-montserrat"
            reverse={true}
          />
        ))}
      </div>
      {/* <div className="sm:w-full lg:w-full">
        <Funds />
      </div> */}
      <div className="w-full flex flex-col lg:flex-row gap-8 lg:gap-0 mt-8 lg:mt-16 justify-between">
        <div className="sm:w-full lg:w-[49.5%]">
          <Target/>
        </div>
        <div className="sm:w-full lg:w-[49.5%]">
          <ReferredMerchants />
        </div>
      </div>
    </>
  );
};

export default FundraiserDashboard;
